import { createContext, useContext, useEffect, useState } from "react";

export const THEMES = ["light", "dark", "synthwave"] as const;
export type Theme = (typeof THEMES)[number];

const STORAGE_KEY = "kandoo-theme";

export function readStoredTheme(): Theme {
  const t = localStorage.getItem(STORAGE_KEY);
  return t === "dark" || t === "synthwave" ? t : "light";
}

const ThemeContext = createContext<{
  theme: Theme;
  setTheme: (t: Theme) => void;
}>({ theme: "light", setTheme: () => {} });

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>(readStoredTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

export const THEME_LABELS: Record<Theme, string> = {
  light: "Light",
  dark: "Dark",
  synthwave: "Synthwave",
};
